export default "__VITE_ASSET__C3$tYq7D__"